import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DateRangeSelectionComponent } from './date-range-selection.component';

@NgModule({
  declarations: [DateRangeSelectionComponent],
  imports: [
    CommonModule,
    FormsModule,
    DateInputsModule
  ],
  exports: [DateRangeSelectionComponent]
})
export class DateRangeSelectionModule { }
